// SELLER
export const META_LOGO_CONFIRMATION = 'logoConfirmation'
export const META_CALENDAR_BANNER = 'calendarBanner'
export const META_MAX_TICKETS_FOR_PURCHASE = 'maxTicketsForPurchase'
export const META_EVENT_DETAILS_SELLER_ALERT = 'eventDetailsSellerAlert'
export const META_SLIDER = 'slider'
export const META_INTERRUPT_MODAL_URL = 'portalPassEventUrl'
export const META_INTERRUPT_MODAL_BODY = 'portalPassModalBody'
export const META_INTERRUPT_MODAL_CONFIRM_BUTTON = 'portalPassModalConfirmButton'
export const META_INTERRUPT_MODAL_DISMISS_BUTTON = 'portalPassModalDismissButton'
export const META_INTERRUPT_BANNER_BODY = 'portalPassBannerBody'
export const META_INTERRUPT_BANNER_BODY_MINIMIZED = 'portalPassBannerBodyMinimized'
export const META_EXHIBITION_INFORMATION = 'exhibitionInformation'
export const META_PRICING_INFORMATION = 'pricing'
export const META_TAXES_WAIVED_ENABLED = 'slrTktTaxWaivedEnabled'
export const META_TAXES_WAIVED_MESSAGE_NO_TAX = 'slrTktTaxWaivedMsgNoTax'
export const META_TAXES_WAIVED_MESSAGE_WITH_TAX = 'slrTktTaxWaivedMsgWithTax'

// SELLER — cutover-pending `slr:tkt:*` keys, see utils/data-access/seller-fallbacks.ts
export const META_FAQ_URL = 'slrTktFaqUrl'
export const META_STATE_CODE = 'slrTktStateCode'
export const META_STATE_NAME = 'slrTktStateName'
export const META_NEWSLETTER_OPTIN_EVENT = 'slrTktNewsletterOptinEvent'
export const META_HEADER_COLOR = 'slrTktHeaderColor'
export const META_EVENTS_DESCRIPTION = 'slrTktEventsDescription'
export const META_EVENTS_HEADER_ANIMATION_URL = 'slrTktEventsHeaderAnimationUrl'
export const META_EVENTS_HEADER_IMAGE_URL = 'slrTktEventsHeaderImageUrl'
export const META_HUBSPOT_NEWSLETTER_FORM_ID = 'slrTktHubspotNewsletterFormId'
export const META_HUBSPOT_PORTAL_ID = 'slrTktHubspotPortalId'
export const META_ENABLED_EVENTS_NEWSLETTER = 'slrTktEnabledEventsNewsletter'
export const META_PERK100_CHECKOUT_RULE_ID = 'slrTktPerk100CheckoutRuleId'
export const META_SEO_TITLE = 'slrTktSeoTitle'
export const META_SEO_DESCRIPTION = 'slrTktSeoDescription'
export const META_SEO_SHARE_TITLE = 'slrTktSeoShareTitle'
export const META_SEO_SHARE_IMAGE_URL = 'slrTktSeoShareImageUrl'
export const META_SEO_CANONICAL_URL = 'slrTktSeoCanonicalUrl'
export const META_EXHIBITION_NAME = 'slrTktExhibitionName'
export const META_CITY_NAME = 'cityName'
export const META_PORTAL_PASS_DAY_PASS_ENABLED = 'slrTktPortalPassDayPassEnabled'
export const META_WEB_ENABLED = 'slrTktWebEnabled'
export const META_URL_SLUG = 'slrTktUrlSlug'
export const META_LANDING_PAGE_URL = 'slrTktLandingPageUrl'
export const META_ICON_URL = 'slrTktIconUrl'
export const META_LOGO_URL = 'slrTktLogoUrl'
export const META_CARD_BACKGROUND_URL = 'slrTktCardBackgroundUrl'
export const META_LANDING_ORDER = 'slrTktLandingOrder'

// TICKET TYPE — cutover-pending `tt:tkt:*` keys
export const META_MAX_TICKETS_FOR_ORDER = 'ttTktMaxTicketsForOrder'

// EVENT OR TICKET GROUP — Ticketure's SmartWaiver keys, https://support.ticketure.com/waiver-integration-and-configuration
export const META_WAIVER_NEEDED = 'waiverNeeded'
export const META_WAIVER_TEMPLATE = 'waiverTemplate'

// EVENT
export const CONFIG_PRICE_DISPLAY = 'price_display'
export const META_ADDITIONAL_PRICING_IDS = 'additionalPricingIds'

export const META_SESSION_END_TIME_OFFSET = 'sessionEndTimeOffset'
export const META_DAY_PASS_BUTTON_TEXT = 'dayPassButtonText'
export const META_DAY_PASS_DESCRIPTION = 'dayPassDescription'
export const META_URL_NAME = 'urlName'
export const META_SUPPORTING_ACTS = 'supportingActs'
export const META_IMAGE_PROFILE = 'imageProfile'
export const META_IMAGE_COVER = 'imageCover'
export const META_ADDONS = 'addons'
export const META_LIFETIME_TICKETS = 'lifetimeTickets'
// TODO: unused by Ticketing Ops (confirmed with Michelle 8/5/26) remove this
// https://app.asana.com/1/23646394350278/project/1206566497440920/task/1217199622292463
export const META_EXCLUDE_TICKET_GROUP = 'mwtixHideTicketGroup'
export const META_UP_FRONT_FEE = 'upFrontFee'
export const META_INTERNAL_TICKET_URL_SLUG = 'internalTicketUrlSlug'
export const META_EVENT_NOTIFICATION_TEXT = 'eventNotificationText'
export const META_EVENT_TYPE = 'eventType'
export const META_SHOW_START = 'showStart'
export const META_EVENTS_HEADER_DESCRIPTION = 'mwHeaderDescription'

export const META_RAW_PERK_FREE_TICKETS = 'mwb_count'
export const META_RAW_PRIMARY_ADMISSION = 'primary_admission'
export const META_RAW_LOCAL = 'local'
export const META_RAW_PHONE = 'phone_number'
export const META_RAW_ZIP_CODE = 'zip_code'
export const META_RAW_COUNTRY = 'country'
export const META_RAW_NEWSLETTER = 'newsletter'
export const META_RAW_UP_FRONT_FEE = 'up_front_fee'
